module.exports = __webpack_public_path__ + "static/WEDDING E&M-434-eb85f0c140c61c6b0edb2507cf021821.jpg";